export default "__VITE_ASSET__BMuW7vs0__"